import { ContentfulAnchor } from '@jbhi-fi/apis/src/contentful/types';
import { ScrollTargetProps } from '../../ScrollTarget/ScrollTarget';
import { toUrlSlug } from '@jbhi-fi/utils/src/toUrlSlug/toUrlSlug';

export abstract class AnchorTransformer {
  static toScrollTargetProps = (entry: ContentfulAnchor): ScrollTargetProps => {
    return {
      id: toUrlSlug(entry?.fields?.heading ?? ''),
    };
  };
}
